import React from "react";

import { Icon } from "@chakra-ui/react";
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdLock,
  MdMoney, MdCalendarMonth,
} from "react-icons/md";
import {
  FaUsers
} from "react-icons/fa";

import Login from "views/auth/login";
import Logout from "views/auth/logout";
import Register from "views/auth/register";
import MainDashboard from "views/user/default";
import RentalAdd from "./views/user/rental-add";
import Rental from "./views/user/rental";
import UserCalendar from "./views/user/calendar";
import InvoicesUser from "./views/user/invoices";
import UserProfile from "views/user/profile";
import AdminDashboard from "./views/admin/dashboard";
import UsersAdmin from "./views/admin/users";
import InvoicesAdmin from "./views/admin/invoices";
import RentalsAdmin from "views/admin/rentals";
import Verify from "./views/auth/verify";
import Reset from "./views/auth/reset";
import ForgotPassword from "./views/auth/forgot-password";

const routes = [
  {
    name: "Deine Inserate",
    layout: "/user",
    path: "/dashboard",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: MainDashboard,
    visible: true,
  },
  {
    name: "Inserat anlegen",
    layout: "/user",
    icon: <Icon as={MdBarChart} width='20px' height='20px' color='inherit' />,
    path: "/add-rental/:id",
    component: RentalAdd,
  },
  {
    name: "Inserat Editor",
    layout: "/user",
    icon: <Icon as={MdBarChart} width='20px' height='20px' color='inherit' />,
    path: "/rental/:id",
    component: Rental,
  },
  {
    name: "Kalender",
    layout: "/user",
    icon: <Icon as={MdCalendarMonth} width='20px' height='20px' color='inherit' />,
    path: "/calendar",
    component: UserCalendar,
    visible: true,
  },
  {
    name: "Deine Rechnungen",
    layout: "/user",
    icon: <Icon as={MdMoney} width='20px' height='20px' color='inherit' />,
    path: "/myinvoices",
    component: InvoicesUser,
    visible: true,
  },
  {
    name: "Dein Profil",
    layout: "/user",
    path: "/profile",
    icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
    component: UserProfile,
    visible: true,
  },
  {
    name: "Dashboard",
    layout: "/admin",
    icon: <Icon as={MdBarChart} width='20px' height='20px' color='inherit' />,
    path: "/dashboard",
    component: AdminDashboard,
    visible: true,
  },
  {
    name: "Kunden",
    layout: "/admin",
    icon: <Icon as={FaUsers} width='20px' height='20px' color='inherit' />,
    path: "/users",
    component: UsersAdmin,
    visible: true,
  },
  {
    name: "Inserate",
    layout: "/admin",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    path: "/rentals",
    component: RentalsAdmin,
    visible: true,
  },
  {
    name: "Rechnungen",
    layout: "/admin",
    icon: <Icon as={MdMoney} width='20px' height='20px' color='inherit' />,
    path: "/invoices",
    component: InvoicesAdmin,
    visible: true,
  },
  {
    name: "Login",
    layout: "/auth",
    path: "/login",
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: Login,
    visible: false,
  },
  {
    name: "Registrierung",
    layout: "/auth",
    path: "/register",
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: Register,
  },
  {
    name: "Logout",
    layout: "/auth",
    path: "/logout",
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: Logout,
    visible: true,
  },
  {
    name: "Verifizierung",
    layout: "/auth",
    path: "/verify",
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: Verify,
  },
  {
    name: "Reset",
    layout: "/auth",
    path: "/reset",
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: Reset,
  },
  {
    name: "ForgotPassword",
    layout: "/auth",
    path: "/forgot-password",
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: ForgotPassword,
  }
];

export default routes;
